export type SnapshotInput = { organizationId: string; start: string; end: string };
export type SnapshotFile = { index: number; name: string; bytes: number };
export type SnapshotJob = SnapshotInput & {
  id: string;
  ownerId: string;
  status: "running" | "complete" | "failed";
  createdAt: string;
  files: SnapshotFile[];
  error?: string;
};

/** Longest inclusive range one export may cover; wider requests are split by the user. */
export const MAX_SNAPSHOT_DAYS = 31;

export function snapshotWindow(value: unknown): SnapshotInput & { endExclusive: string } {
  const input = value as Partial<SnapshotInput> | null;
  if (!input || typeof input.organizationId !== "string" || !/^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i.test(input.organizationId)) {
    throw new Error("Select an organization");
  }
  for (const field of ["start", "end"] as const) {
    const date = input[field];
    if (typeof date !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(date) || date < "0001-01-01" || date >= "9999-12-31" || !Number.isFinite(Date.parse(`${date}T00:00:00Z`)) || new Date(`${date}T00:00:00Z`).toISOString().slice(0, 10) !== date) {
      throw new Error(`${field} must be a valid date`);
    }
  }
  const start = input.start!;
  const end = input.end!;
  if (end < start) throw new Error("End date must be on or after start date");
  if ((Date.parse(`${end}T00:00:00Z`) - Date.parse(`${start}T00:00:00Z`)) / 86_400_000 + 1 > MAX_SNAPSHOT_DAYS) {
    throw new Error(`A date range can cover at most ${MAX_SNAPSHOT_DAYS} days. Split longer periods into several requests.`);
  }
  const endExclusive = new Date(Date.parse(`${end}T00:00:00Z`) + 86_400_000).toISOString().slice(0, 10);
  return { organizationId: input.organizationId, start, end, endExclusive };
}

export function snapshotFilename(username: string, org: string, start: string, end: string, index: number): string {
  const safe = (value: string) => value.replace(/[^a-zA-Z0-9.-]/g, "_").slice(0, 100);
  return `${safe(username)}_request_${safe(org)}_student_data_snapshot_${start}_${end}_${index}.csv`;
}
